<template>
    <div v-if="isShowPopup" class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex justify-center items-center z-50 p-4"
        @click.self="closedPopup()">
        <div class="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl md:w-[420px] w-full max-h-[90vh] overflow-hidden border border-white/20 flex flex-col"
            :class="{ 'animate-popupFadeIn': isShowPopup, 'animate-popupFadeOut': !isShowPopup }">
            
            <!-- Header -->
            <div class="bg-brand text-yellow-500 py-3.5 px-5 font-bold text-[18px] flex items-center justify-between shadow-sm relative z-10">
                <div class="flex items-center gap-2">
                    <font-awesome-icon :icon="['fas', 'circle-check']" /> Xác nhận OTP
                </div>
                <button @click="closedPopup()" class="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white/90 hover:bg-white hover:text-brand transition-colors focus:outline-none">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
            </div>

            <!-- Body items -->
            <div class="p-6 overflow-y-auto flex flex-col items-center">
                <div class="text-[16px] text-brand font-bold mb-2">Nhập mã xác thực</div>
                <div class="text-[14px] text-gray-500 mb-6 text-center leading-relaxed">
                    Vui lòng mở ứng dụng <b>Google Authenticator</b> và nhập mã 6 số để hoàn tất thiết lập bảo mật 2FA
                </div>
                
                <div class="flex gap-2 justify-center mb-4 w-full px-2" dir="ltr">
                    <input
                        v-for="(digit, index) in otp"
                        :key="index"
                        v-model="otp[index]"
                        maxlength="1"
                        ref="otpInput"
                        class="w-12 h-14 text-center text-2xl font-bold text-gray-800 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all shadow-sm placeholder-gray-300"
                        @input="onInput(index)"
                        @keydown.backspace="onBackspace(index)"
                    />
                </div>
            </div>
            
            <!-- Footer -->
            <div class="p-5 bg-gray-50/80 border-t border-gray-100 flex items-center justify-center rounded-b-2xl">
                <button
                    class="w-full py-3 rounded-xl font-bold bg-brand text-white shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all flex justify-center items-center gap-2"
                    @click="submitOtp">
                    Xác nhận hoàn tất <font-awesome-icon :icon="['fas', 'check']" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isShowPopup: false,
            otp: ['', '', '', '', '', ''],
        }
    },
    mounted() {
        if(this.isShow) {
            this.isShowPopup = true
            document.body.style.overflow = 'hidden'
        }
    },
    beforeDestroy() {
        document.body.style.overflow = ''
    },
    methods: {
        closedPopup(returnData = false) {
            this.isShowPopup = false
            this.$nextTick(() => {
                this.$emit('closed', returnData)
            })
        },
        onInput(index) {
            const value = this.otp[index];
            if (!/^\d$/.test(value)) {
                this.otp.splice(index, 1, '');
                return;
            }

            if (value && index < this.otp.length - 1) {
                this.$refs.otpInput[index + 1].focus();
            }
        },
        onBackspace(index) {
        if (!this.otp[index] && index > 0) {
            this.$refs.otpInput[index - 1].focus();
        }
        },
        async submitOtp() {
            let code = this.otp.join('');
            if(code.length == 6) {

                await this.$axios.post(`${API_URL}/authuserslog/active-2fa`, {
                    token: code,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Authorization': `Bearer ${this.$app.token}`,
                    },
                }).then(async res => {
                    if(res.data.success) {
                        this.$notify.success({
                            title: 'Thành công',
                            message: res.data.message
                        });
                        setTimeout(() => {
                            window.location.reload();
                        },200)
                        // this.closedPopup(true)
                    } else {
                        this.$notify.error({
                            title: 'Thất bại',
                            message: res.data.message
                        });
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: 'Thất bại',
                        message: err
                    });
                })
            } else {
                 this.$notify.error({
                    title: 'Thất bại',
                    message: 'Vui lòng nhập đầy đủ OTP'
                });
            }
        }
    }
}
</script>

<style scoped>
@keyframes popupFadeIn {
    0% { opacity: 0; transform: translateY(10px); }
    100% { opacity: 1; transform: translateY(0); }
}
@keyframes popupFadeOut {
    0% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(10px); }
}
.animate-popupFadeIn { animation: popupFadeIn 0.4s forwards; }
.animate-popupFadeOut { animation: popupFadeOut 0.4s forwards; }
</style>